/**
 * GraphQL Query that fetches products using received search term and the params
 * for filter, sort and pagination.
 */
export default `
  query getFacetData($search: String = "", $filter: ProductAttributeFilterInput, $pageSize: Int = 10, $currentPage: Int = 1, $sort: ProductAttributeSortInput) {
    products(search: $search, filter: $filter, pageSize: $pageSize, currentPage: $currentPage, sort: $sort) {
      items {
        __typename
        uid
        sku
        name
        id
        stock_status
        qty
        low_stock_pop_up
        stock_display_status
        button_text
        manufacturer_name
        manufacturer_part_no
        tab_box
        tab_specs_dims
        discontinued
        hideprice
        hidestock
        special_order
        only_x_left_in_stock
        qty
        category_image
        am_product_labels {
          label_id
          product_id
          name
          txt
          is_visible
          image
          position
          size
          style
          tooltip_settings {
              status
              color
              text_color
              text
          }
          customer_group_ids
          redirect_url
          alt_tag
        }
        am_category_labels {
          label_id
          product_id
          name
          txt
          is_visible
          image
          position
          size
          style
          tooltip_settings {
              status
              color
              text_color
              text
          }
          customer_group_ids
          redirect_url
          alt_tag
        }
        thumbnail {
          url
          position
          disabled
          label
        }
        url_key
        url_rewrites {
          url
        }
        short_description {
          html
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
        }
        ... on GroupedProduct {
          items {
            product {
              sku
            }
          }
        }
      }
      page_info {
        current_page
        page_size
        total_pages
      }
      total_count
    }
  }
`;
